import { Link } from "react-router-dom";
import { T, useLang } from "@/i18n";
import { LangSwitcher } from "@/components/LangSwitcher";

export default function PaymentCancel() {
  const [lang, setLang] = useLang();
  const t = T[lang].cancel;

  return (
    <div className="bg-[#200910] text-[#faf6ef] min-h-screen font-sans flex items-center justify-center px-6">
      <div className="max-w-xl w-full border border-[#4d1a2a] bg-[#33101c] p-10" data-testid="payment-cancel-page">
        <div className="flex justify-end mb-6"><LangSwitcher lang={lang} setLang={setLang} /></div>
        <span className="font-mono-lbl text-xs uppercase tracking-[0.18em] text-[#d3b870]">{t.k}</span>
        <h1 className="font-display uppercase text-3xl mt-3">{t.t}</h1>
        <p className="text-sm text-[#b4939c] mt-4">
          {t.d}
        </p>
        <Link to="/#pacchetti" data-testid="retry-payment-link"
          className="inline-block mt-8 px-6 py-3 bg-[#d3b870] text-[#200910] font-display uppercase tracking-wider text-sm hover:bg-[#ecd9ab] transition-colors">
          {t.btn}
        </Link>
      </div>
    </div>
  );
}
